/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  lang: 'ENG',
  newCurrentScene: '01',
  active: false,
};

export const sceneSlice = createSlice({
  name: 'sceneController',
  initialState,
  reducers: {
    selectScene: (state, action) => {
      state.newCurrentScene = action.payload;
    },
    selectLang: (state, action) => {
      state.lang = action.payload;
    },
    setActive: (state, action) => {
      state.active = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { selectScene, selectLang, setActive } = sceneSlice.actions;

export default sceneSlice.reducer;
